export const searchFilterConstant = {
  'produto.id_produto': 'Código',
  id_entidade: 'Código',
  id_pedido: 'Código',
  referencia_afere: 'Referência',
  'produto.descricao': 'Descrição',
  'f.descricao': 'Família',
  data_emissao: 'Data emissão',
  'c.razao_social_nome': 'Cliente',
  's.sigla': 'Status',
  razao_social_nome: 'Nome',
  cnpjcpf: 'CNPJ/CPF',
  'c.nome': 'Cidade',
}
